export default __webpack_public_path__ + "static/media/ThinkFarming.8d119726b82c571776b97213e7bfcb09.webp";